import { useRecordContext } from "react-admin";
import ReturnCorrectionModal from "components/CareerCenter/Partials/ReturnCorrectionModal";
import { careerCenterRequests } from "api/careerCenterApi";

const ReturnEmployerForCorrection = () => {
  const record = useRecordContext();

  return <ReturnCorrectionModal correctionsUrl={careerCenterRequests.returnForCorrectionEmployer(record?.id)} />;
};

export default ReturnEmployerForCorrection;
